import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import "../../Style/LandingPage.css";
import { Avatar } from "@mui/material";
import Data_Table from "./Data_Table";
import CustomerDetails from "./CustomerDetails";
import defaultAvatar from "../../Images/default-avatar.svg";
import bb3 from "../../Images/bb3.jpg";
import { FaPaintBrush } from "react-icons/fa";
import { AiOutlineFileWord } from "react-icons/ai";
import { AiOutlineFilePdf } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { BiImage } from "react-icons/bi";
import axios from "axios";
import { path_url } from "../../Config/config";
import {
  faCirclePlus,
  faPlus,
  faPlusSquare,
  faSquarePlus,
  faPenToSquare,
  faFileInvoice,
  faTasks,
  faReceipt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VendorProfileCard from "../components/VendorProfileCard";
import VendorDetailsTables from "../components/VendorDetailsTables";
import "../../Style/CrmDashboard.css";
import OutsideClickHandler from "react-outside-click-handler";
import QuickEmailModal from "../components/QuickEmailModal";
import CreateTaskModal from "../components/CreateTaskModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function VendorDetailsParent() {
  const navigate = useNavigate();
  const vendorId = useParams();
  const [showComponent, setShowComponent] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [profile, setProfile] = useState([]);
  const [Details, setDetails] = useState([]);
  const [showMobileButtons, setShowMobileButtons] = useState(true);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);

  const [dropdownStates, setDropdownStates] = useState({
    purchase: false,
    quotation: false,
    contact: false,
    task: false,
    service: false,
    sendMail: false,
  });

  const toggleDropdown = (name) => {
    setDropdownStates((prev) => ({
      purchase: false,
      quotation: false,
      contact: false,
      task: false,
      service: false,
      sendMail: false,
      [name]: !prev[name],
    }));
  };

  const closeDropdown = (name) => {
    setDropdownStates((prev) => ({ ...prev, [name]: false }));
  };

  const closeAllDropdowns = () => {
    setDropdownStates({
      purchase: false,
      quotation: false,
      contact: false,
      task: false,
      service: false,
      sendMail: false,
    });
  };

  const handleCreateTask = () => {
    closeAllDropdowns();
    setIsTaskModalOpen(true);
  };

  const handleViewTask = () => {
    closeAllDropdowns();
    const el = document.getElementById("vendor-tasks-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleTaskCreated = () => {
    setIsTaskModalOpen(false);
    fetchdetails();
  };

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  useEffect(() => {
    fetchdetails();
    return () => {
      window.__CRM_PAGE_CONTEXT__ = null;
      window.dispatchEvent(new CustomEvent("crm-context-updated"));
    };
  }, []);
  async function fetchdetails() {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await axios.get(
        `${path_url}/vendor/details/${vendorId.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      setDetails(response.data.body);
      setProfile(response.data.body.vendor);
      window.__CRM_PAGE_CONTEXT__ = {
        type: "vendor",
        profile: response.data.body.vendor,
        details: response.data.body
      };
      window.dispatchEvent(new CustomEvent("crm-context-updated"));
    } catch (error) {
      console.error(error.message);
    }
  }
  const handleMobileButtonClick = () => {
    setShowMobileButtons(!showMobileButtons);
  };

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div>
            <div
              className="col-12 w-9 d-flex justify-content-center"
              style={{ paddingTop: 5, position: "relative" }}
            >
              <img
                src={bb3}
                alt=""
                style={{
                  width: "100%",
                  height: "5rem",
                  objectFit: "cover",
                  backgroundPosition: "center",
                }}
              />
              <Avatar
                src={defaultAvatar}
                className="my-5"
                style={{
                  position: "absolute",
                  left: "51%",
                  transform: "translateX(-50%)",
                  zIndex: 3,
                  width: "6rem",
                  height: "6rem",
                  border: "3px solid #ffffff",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#e2e8f0",
                }}
              />
            </div>
            <div className="col-12 justify-content-center">
              <div
                className="row justify-content-center"
                style={{ marginTop: "3.3rem" }}
              >
                <div className="content-header">
                  <div className="content-fluid">
                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <h4>Vendor Details</h4>
                      </div>
                      <div className="col-sm-6">
                        <ul className="breadcrumb float-sm-right mb-4">
                          <li className="breadcrumb-item">
                            <a href="#">Home</a>
                          </li>
                          <li className="breadcrumb-item">General Form</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 bg-white">
                  <div className="row customer-detail">
                    <div className="col-md-4 mt-2">
                      <div
                        className="mt-2"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "0.5rem",
                        }}
                      >
                        {document.documentElement.clientWidth <= 768 ? (
                          <button
                            className="btn btn-md bg-gradient-primary"
                            style={{
                              background:
                                "#007bff linear-gradient(180deg,#268fff,#007bff) repeat-x",
                              color: "#fff",
                              display: "flex",
                              gap: "0.5rem",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "1.2rem",
                              margin: "0 auto",
                            }}
                            onClick={handleMobileButtonClick}
                          >
                            {showMobileButtons ? "Hide" : "Show"} Buttons
                          </button>
                        ) : null}
                        {showMobileButtons ? (
                          <>
                            <div
                              className="pbuttons"
                              style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}
                            >
                              <div
                                className="rightside dropdown"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "0.5rem",
                                }}
                              >
                                {/* Purchase Dropdown */}
                                <OutsideClickHandler
                                  onOutsideClick={() => closeDropdown("purchase")}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={() => toggleDropdown("purchase")}
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    Purchase
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      dropdownStates.purchase ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        navigate("/create-purchase-order", {
                                          state: { vendorId: vendorId.id, vendor: profile },
                                        });
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Purchase Order
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        document.getElementById("vendor-purchase-section")?.scrollIntoView({ behavior: "smooth" });
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Purchase Order
                                    </div>
                                  </div>
                                </OutsideClickHandler>



                                {/* Quotation Dropdown */}
                                <OutsideClickHandler
                                  onOutsideClick={() => closeDropdown("quotation")}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={() => toggleDropdown("quotation")}
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    Quotation
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      dropdownStates.quotation ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        navigate("/create-quotation", {
                                          state: { vendorId: vendorId.id, vendor: profile },
                                        });
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                      Create Quotation
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        navigate("/quotations");
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Quotation
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                {/* Contact Dropdown */}
                                <OutsideClickHandler
                                  onOutsideClick={() => closeDropdown("contact")}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={() => toggleDropdown("contact")}
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    Contact
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      dropdownStates.contact ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        setShowEmailModal(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faEnvelope} /> Send
                                      Email
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                {/* Create Task Dropdown */}
                                <OutsideClickHandler
                                  onOutsideClick={() => closeDropdown("task")}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={() => toggleDropdown("task")}
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    Create Task
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      dropdownStates.task ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      className="dropdown-item"
                                      onClick={handleCreateTask}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src="/assets/Create_task.png"
                                        alt="create task"
                                        style={{
                                          height: "25px",
                                          width: "17px",
                                          marginLeft: "-3px",
                                        }}
                                      />{" "}
                                      Create Task
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      onClick={handleViewTask}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faTasks} /> View
                                      Task
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                {/* Service Dropdown */}
                                <OutsideClickHandler
                                  onOutsideClick={() => closeDropdown("service")}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={() => toggleDropdown("service")}
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    Service
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      dropdownStates.service ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        document.getElementById("vendor-service-section")?.scrollIntoView({ behavior: "smooth" });
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faReceipt} /> View
                                      Service Request
                                    </div>
                                  </div>
                                </OutsideClickHandler>

                                {/* Send Mail Dropdown */}
                                <OutsideClickHandler
                                  onOutsideClick={() => closeDropdown("sendMail")}
                                >
                                  <button
                                    className="btn bg-gradient-primary dropdown-toggle"
                                    data-toggle="dropdown"
                                    onClick={() => toggleDropdown("sendMail")}
                                    style={{
                                      background: "rgb(227, 233, 237) repeat-x",
                                      color: "black",
                                      display: "flex",
                                      gap: "0.5rem",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "1.0rem",
                                      fontSize: "small",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                  >
                                    Send Mail
                                  </button>
                                  <div
                                    className={`dropdown-menu ${
                                      dropdownStates.sendMail ? "show" : ""
                                    } dropdown-menu-end`}
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <div
                                      className="dropdown-item"
                                      onClick={() => {
                                        closeAllDropdowns();
                                        setShowEmailModal(true);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FontAwesomeIcon icon={faEnvelope} /> Send
                                      Mail
                                    </div>
                                  </div>
                                </OutsideClickHandler>
                              </div>
                            </div>
                          </>
                        ) : (
                          <> </>
                        )}
                      </div>

                      <div className="vendor-profile mt-2">
                        <VendorProfileCard Details={profile} onSendMail={() => setShowEmailModal(true)} />
                      </div>
                    </div>

                    <div className="col-md-8 mt-5">
                      <div className="row" style={{ marginTop: "30px" }}>
                        <div className="col-md-4 mb-3">
                          <div
                            className="info-box bg-light"
                            style={{ height: "100%" }}
                          >
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Invoice
                              </span>
                              <span className="info-box-text text-center text-muted mb-0">
                                <b style={{ color: "black" }}>
                                  {Details?.count?.totalInvoice}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div
                            className="info-box bg-light"
                            style={{ height: "100%" }}
                          >
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Service Request
                              </span>
                              <span className="info-box-text text-center text-muted mb-0">
                                <b style={{ color: "black" }}>
                                  {Details?.count?.totalServiceRequets}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div
                            className="info-box bg-light"
                            style={{ height: "100%" }}
                          >
                            <div className="info-box-content">
                              <span className="info-box-text text-center text-muted">
                                Total Order
                              </span>
                              <span className="info-box-text text-center text-muted mb-0 ">
                                <b style={{ color: "black" }}>
                                  {Details?.count?.totalOrders}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Details?.dueToday?.length ? (
                        <Data_Table
                          tableData={Details?.dueToday}
                          title={"Due Today data"}
                        />
                      ) : (
                        ""
                      )}
                      <Data_Table
                        tableData={Details?.openItemsList}
                        title={"Open Items List"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <VendorDetailsTables
            Details={Details}
            refetchDetails={fetchdetails}
            onOpenTaskModal={handleCreateTask}
          />
          <UserFooter />
        </div>
      </div>

      <CreateTaskModal
        open={isTaskModalOpen}
        onClose={() => setIsTaskModalOpen(false)}
        vendorId={vendorId.id}
        onTaskCreated={handleTaskCreated}
      />

      <QuickEmailModal
        isOpen={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        contact={profile}
        contactType="Vendor"
      />
    </>
  );
}
